<template>
  <header>
    <CCard class="flex-y-center justify-between p-4 mb-4">
      <RouterLink to="/">
        <img
          src="/logo/saraf-logo-mobile.svg"
          alt="Saraf Logo"
          class="w-8 h-8"
        />
      </RouterLink>
      <div class="flex-y-center gap-4">
        <CLanguageSwitcher
          class="border border-gray-250 rounded-xl py-1 px-2"
        />
        <Notification />
        <CProfileDropdown mobile v-if="user?.id" :user="user" />
      </div>
    </CCard>
    <CCard class="flex-y-center justify-between p-4 mb-4">
      <div id="header-breadcrumbs" class="w-full md:w-auto" />
    </CCard>
  </header>
</template>

<script setup lang="ts">
import CCard from "@/components/Card/CardWrapper.vue";
import { useAuthStore } from "@/modules/Auth/stores";
import { computed } from "vue";
import CLanguageSwitcher from "@/components/CLanguageSwitcher.vue";
import Notification from "@/modules/Notification/components/Notification.vue";
import CProfileDropdown from "@/layout/Dashboard/components/CProfileDropdown.vue";

const store = useAuthStore();

const user = computed(() => store.user);
</script>

<style scoped></style>
